angular.module("vgresiduos").factory("systemMtrSystemService", [
	"$http",
	function ($http) {
		"use strict";

		const _listMtrSystems = function (params) {
			let queryString = "";
			if (params) {
				queryString = "?" + params;
			}

			const req = {
				method: "get",
				url: Vgr.constants.integrationsHostUrl + Vgr.resources.integrations.systemMtrSystems + queryString
			};
			return $http(req);
		};

		return {
			listMtrSystems: _listMtrSystems
		};
	}
]);
